import React, { Component } from 'react';
import { Input } from 'reactstrap';
import { connect } from 'react-redux';
import NavBar from '../../../_components/common/Navbar';

import { tables } from './AssessmentSummaryTableData';
import TableNew from '../../../_components/common/TableNew'
import Aux from '../../../_components/common/Hoc';
import Page404 from '../../404page';
import { LoaderComp } from '../../../_components/common/LoaderComp/Loadercomp';


import { organisationAction } from '../../../_actions/organisation.action';
import { GroupReportAction } from '../../../_actions/organisations/groupReport.action';



import { getBatchAction, getAssessementAction } from '../../../_actions';
import { Link } from 'react-router-dom'
import { CommonBreadCrumb } from '../../../_components/common/CommonBreadCrumb';

import Select from 'react-select';


//modal
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Axios from 'axios';
import swal from 'sweetalert2';

class AssessmentSummary extends Component {

	state = {
		instrumentId: null,
		assessorSelectedOption: null,
		assessorDropdownOption: [],
		assessmentIds: [],
		modal: false,
		showTable: false,
		orgId: 'null',
		selId: null,
		BatchId: 'null',
		sortType: false,
		assessmentData: '',
		addGroupReport: false,
		value: '',
		assessorsList: [],
		instrumentId: 0,
		assessorId: [],
		currentOrg: [],
		groupReportModal: false,
		reportDownloadDisable: true,
		showDropDownInModal: false,


		hasProperOrgId: true,
		idLoader: true,
	}

	componentDidMount() {

		this.props.dispatch(organisationAction.getOrganisation((callback_Data) => {
			const query = new URLSearchParams(this.props.location.search);
			const ids = {}

			for (let param of query.entries()) {
				ids[param[0]] = param[1];
			}

			ids !== {} &&
				this.setState({
					showTable: ids.organisation ? true : false
				})
			if (ids.organisation) {
				const selId = this.getSellerId(+ids.organisation);

				this.setState({
					orgId: +ids.organisation,
					BatchId: ids.batch === 'unalloted' ? null : +ids.batch,
					instrumentId: ids.instrument ? +ids.instrument : null,
				})
				const data = {
					"batch_id": ids.batch === 'unalloted' ? null : +ids.batch,
					"organisation_id": +ids.organisation
				}

				if (ids.instrument) {
					data.instrument_id = +ids.instrument;
				}

				let hasId = false
				for (let i = 0; i < callback_Data.data.organisation_list.length; i++) {
					const element = callback_Data.data.organisation_list[i];
					if (element.id == ids.organisation) {
						hasId = true
						this.props.dispatch(getAssessementAction.getAssessementHandler(data))
						this.props.dispatch(getBatchAction.getBatchHandler(selId, +ids.organisation))
					}
				}

				this.setState({
					hasProperOrgId: hasId,
					idLoader: false
				})
			} else {
				this.setState({
					hasProperOrgId: true,
					idLoader: false
				})
			}
		}))


	}

	getSellerId(id) {
		const { loading, organisationResponse } = this.props;

		if (loading === false) {
			for (let i in organisationResponse) {
				if (+organisationResponse[i].id === +id) {

					this.setState({
						currentOrg: organisationResponse[i],
						selId: organisationResponse[i].seller__id
					})

					return organisationResponse[i].seller__id;
				}
			}
		}

		const data = {
			"batch_id": this.state.BatchId,
			"organisation_id": this.state.orgId
		}

	}

	onChangeOrganisation = (ev) => {
		if (ev.target.value !== "null") {
			const selId = this.getSellerId(ev.target.value);
			const eventValue = ev.target.value

			this.setState({
				showTable: true,
				orgId: ev.target.value,

				selId: selId,
				instrumentId: null
			}, () => {
				const queryParams = [];
				queryParams.push(encodeURIComponent('organisation') + '=' + encodeURIComponent(eventValue))
				queryParams.push(encodeURIComponent('batch') + '=' + encodeURIComponent('unalloted'))
				const queryString = queryParams.join('&');
				this.props.history.push({
					search: '?' + queryString
				});
				this.props.dispatch(getBatchAction.getBatchHandler(selId, eventValue))
				const data = {
					"batch_id": null,
					"organisation_id": eventValue
				}
				this.props.dispatch(getAssessementAction.getAssessementHandler(data))
			});

		}
		if (ev.target.value === "null") {
			this.props.history.push({
				search: ''
			});
			this.setState({
				showTable: false,
				value: '',
			});
		}

	}

	onChangeBatch = (ev) => {
		let data = null;
		if (ev.target.value === "Unalloted") {
			const queryParams = [];
			queryParams.push(encodeURIComponent('organisation') + '=' + encodeURIComponent(this.state.orgId))
			queryParams.push(encodeURIComponent('batch') + '=' + encodeURIComponent('unalloted'))

			if (this.state.instrumentId) {
				queryParams.push(encodeURIComponent('instrument') + '=' + encodeURIComponent(this.state.instrumentId));
			}
			const queryString = queryParams.join('&');
			this.props.history.push({
				search: '?' + queryString
			});
			this.setState({
				batchId: null
			})
			data = {
				"batch_id": null,
				"organisation_id": this.state.orgId
			}

			// Add instrument_id if it's selected
			if (this.state.instrumentId) {
				data.instrument_id = parseInt(this.state.instrumentId);
			}

		}
		else {
			const queryParams = [];
			queryParams.push(encodeURIComponent('organisation') + '=' + encodeURIComponent(this.state.orgId))
			queryParams.push(encodeURIComponent('batch') + '=' + encodeURIComponent(ev.target.value))
			if (this.state.instrumentId) {
				queryParams.push(encodeURIComponent('instrument') + '=' + encodeURIComponent(this.state.instrumentId));
			}

			const queryString = queryParams.join('&');
			this.props.history.push({
				search: '?' + queryString
			});
			data = {
				"batch_id": ev.target.value,
				"organisation_id": this.state.orgId
			}

			// Add instrument_id if it's selected
			if (this.state.instrumentId) {
				data.instrument_id = parseInt(this.state.instrumentId);
			}



		}


		this.props.dispatch(getAssessementAction.getAssessementHandler(data))
	}

	onChangeInstrument = (ev) => {
		const instrumentId = ev.target.value;

		// Update URL with all parameters
		const queryParams = [];
		queryParams.push(encodeURIComponent('organisation') + '=' + encodeURIComponent(this.state.orgId));
		queryParams.push(encodeURIComponent('batch') + '=' + encodeURIComponent(this.state.BatchId === null ? 'unalloted' : this.state.BatchId));
		if (instrumentId !== "null") {
			queryParams.push(encodeURIComponent('instrument') + '=' + encodeURIComponent(instrumentId));
		}
		const queryString = queryParams.join('&');
		this.props.history.push({
			search: '?' + queryString
		});

		const data = {
			batch_id: this.state.BatchId,
			organisation_id: this.state.orgId
		};

		if (instrumentId !== "null") {
			data.instrument_id = parseInt(instrumentId);
		}

		this.setState({
			instrumentId
		}, () => {
			this.props.dispatch(getAssessementAction.getAssessementHandler(data));
		});
	}




	compareBy(key) {
		if (this.state.sortType == true) {
			return function (a, b) {
				if (a[key].toLowerCase() < b[key].toLowerCase()) return -1;
				if (a[key].toLowerCase() > b[key].toLowerCase()) return 1;
				return 0;
			};
		}

		if (this.state.sortType == false) {
			return function (a, b) {
				if (a[key].toLowerCase() > b[key].toLowerCase()) return -1;
				if (a[key].toLowerCase() < b[key].toLowerCase()) return 1;
				return 0;
			};
		}
	}

	sortBy(columnKey, type, tableName) {
		this.setState({ sortType: type })
		if (tableName === 'assessmentTwo') {
			const arrayCopy = this.props.assessmentResponse;
			arrayCopy.sort(this.compareBy(columnKey));
			this.setState({ assessmentData: arrayCopy })
		}



	}

	getParticipantsCount(instrument) {
		let count = 0;
		this.props.assessmentResponse.map(
			(response, i) => {
				if (response.instrument__instrument_name === instrument) {
					count = count + 1;
				}
			})
		return count
	}

	getYetToStart(instrument, type) {
		let count = 0;
		this.props.assessmentResponse.map(
			(response, i) => {
				if (response.instrument__instrument_name === instrument) {
					if (type === 'yetToStart') {
						if (response.assessment_completed_count === 0) {
							count = count + 1
						}
					}

					if (type === 'inProgress') {
						if (response.assessment_completed_count !== 0 && response.assessment_completed_count < response.assessment_number_count) {
							count = count + 1
						}
					}
				}
			})

		return count
	}

	getSelfCount(instrument) {
		let count = 0;
		this.props.assessmentResponse.map(
			(response, i) => {
				if (response.instrument__instrument_name === instrument) {
					if ((response.assessment_completed_count === response.assessment_number_count) && response.assessment_completed_count != 0) {
						count = count + 1;
					}
				}
			})
		return count
	}

	getTotalRespondentCount(instrument) {
		let count = 0;
		this.props.assessmentResponse.map(
			(response, i) => {
				if (response.instrument__instrument_name === instrument) {
					count = count + response.respondent_count
				}
			})
		return count
	}

	getRespondentsCount(instrument) {
		let count = 0;
		this.props.assessmentResponse.map(
			(response, i) => {
				if (response.instrument__instrument_name === instrument) {
					count = count + response.respondent_completed
				}
			})
		return count
	}

	getAssessmentCount(instrument) {
		let count = 0;
		this.props.assessmentResponse.map(
			(response, i) => {
				if (response.instrument__instrument_name === instrument) {
					if (response.is_submited === true) {
						count = count + 1
					}
				}
			})
		return count
	}

	getExternalLinkStatus(instrument) {
		let count = 0;
		this.props.assessmentResponse.map((response) => {
			if (response.instrument__instrument_name === instrument) {
				if (response.is_submited === true) {
					count = count + 1
				}
			}
		})
		if (count >= 2) {
			return true
		} else {
			return true
		}
	}

	getParticularInstrumentSummary(instrument) {

		let data = [];

		this.props.assessmentResponse.map(
			(response, i) => {
				if (response.instrument__is_multi_rater && response.instrument__instrument_name === instrument) {
					data = [{
						'id': response.instrument_id,
						'TYPE': response.instrument__instrument_name,
						'TOTAL PARTICIPANTS': this.getParticipantsCount(instrument),
						'SELF COMPLETED': this.getSelfCount(instrument),
						'TOTAL RESPONDENTS': this.getTotalRespondentCount(instrument),
						'RESPONDENTS COMPLETED': this.getRespondentsCount(instrument),
						'ASSESSMENTS SUBMITTED': this.getAssessmentCount(instrument),
						'external_link': this.getExternalLinkStatus(instrument)
					}]
				}
				else if (response.instrument__is_multi_rater === false && response.instrument__instrument_name === instrument) {
					data = [{
						'instrument__instrument_name': response.instrument__instrument_name,
						'TOTAL PARTICIPANTS': this.getParticipantsCount(instrument),
						'YET TO START': this.getYetToStart(instrument, 'yetToStart'),
						'IN PROGRESS': this.getYetToStart(instrument, 'inProgress'),
						'COMPLETED': this.getAssessmentCount(instrument),
						'external_link': this.getExternalLinkStatus(instrument)
					}]

				}
			}
		)

		return data
	}

	getValuesForParticularInstrument(instrument, dropDownData) {
		const data = []
		this.props.assessmentResponse.map(
			(response, j) => {
				if (response.instrument__is_multi_rater && response.instrument__instrument_name === instrument) {
					data.push({
						'id': response.id,
						'instrument_type': response.instrument__is_multi_rater,
						'instrument__instrument_name': [response.instrument__instrument_name,
						response.instrument__instrument_image
						],
						'participant__email': response.participant__email,
						'participant__short_name': response.participant__short_name,
						'assessment_completed_count': response.assessment_completed_count + "/" + response.assessment_number_count,
						'respondent_count': response.respondent_completed + " of " + response.respondent_count + " completed",
						'is_submited': response.is_submited,
					})
				}
				else if (response.instrument__is_multi_rater === false && response.instrument__instrument_name === instrument) {
					data.push({
						'id': response.id,
						'instrument_type': response.instrument__is_multi_rater,
						'instrument__instrument_name': [response.instrument__instrument_name,
						response.instrument__instrument_image
						],
						'participant__email': response.participant__email,
						'participant__short_name': response.participant__short_name,
						'assessment_completed_count': response.assessment_completed_count + "/" + response.assessment_number_count,

						'is_submited': response.is_submited,
					})
				}
			})

		return data
	}

	getInstrumentType(instrument) {
		let data = null;
		let addGroupReport = false;
		let multiRaterCounter = 0;
		let singleRaterCounter = 0;
		this.props.assessmentResponse.map(
			(response, j) => {
				if (response.instrument__is_multi_rater === true && response.instrument__instrument_name === instrument) {
					data = true
					if (response.is_submited) {
						multiRaterCounter++
						if (multiRaterCounter >= 2) {
							addGroupReport = true
						}
					}

				}
				else if (response.instrument__is_multi_rater === false && response.instrument__instrument_name === instrument) {
					data = false
					if (response.is_submited) {
						singleRaterCounter++
						if (singleRaterCounter >= 2) {
							addGroupReport = true
						}
					}
				}
			})
		return {
			data,
			addGroupReport
		}
	}

	openModal(data, instrument) {
		const { dispatch } = this.props;



		let assessorDropdownOption = []

		let instrumentId = 0;
		let assessmentIds = [];
		this.props.assessmentResponse.map(val => {
			if (data.id === undefined) {
				if (val.instrument__instrument_name === data.instrument__instrument_name) {
					instrumentId = val.instrument_id
					if (val.is_submited) {
						assessmentIds.push(val.id)
					}
				}
			} else {
				if (val.instrument_id === data.id) {
					instrumentId = val.instrument_id
					if (val.is_submited) {
						assessmentIds.push(val.id)
					}
				}
			}
		})

		dispatch(GroupReportAction.groupReportAssesorList({ assessment_ids: assessmentIds }, (resp_assessor_data) => {

			assessorDropdownOption.push({
				value: 0,
				label: 'Self'
			})


			resp_assessor_data.data.data.map(val => {
				assessorDropdownOption.push({
					value: val.assessor_group__id,
					label: val.assessor_group__assessor_name
				})
			})

			this.setState({
				groupReportModal: !this.state.groupReportModal,
				assessorDropdownOption,
				instrumentId,
				assessmentIds,
				showDropDownInModal: instrument === 'VVI' ? false : true
			})

		}))


	}

	getValueForRelation(relation) {

		for (let i in this.state.currentOrg.assessor_group) {
			if (this.state.currentOrg.assessor_group[i].assessor_group__assessor_name === relation.assessor_name) {

				return true
			}
		}

		return false

	}

	chooseAssessor(data) {

		let assessorId = [];
		data.map(val => {
			assessorId.push(val.value)
		})
		this.setState({
			assessorId,
			assessorSelectedOption: data,
			reportDownloadDisable: data.length !== 0 ? false : true
		}, () => {

		})
	}

	toggleEntireRelationModal(showModal) {
		this.setState({
			groupReportModal: showModal
		})
	}

	render() {

		const { organisationResponse, loading, organisationError, batchListResponse, getBatchLoading, getAssessmentLoading, assessmentResponse } = this.props;

		

		const getInstruments = [];

		{
			!getAssessmentLoading &&
				assessmentResponse.map(
					(response, i) => {
						let flag = 0;
						for (let j in getInstruments) {
							if (getInstruments[j] === response.instrument__instrument_name) {
								flag = 1
							}
						}
						if (flag === 0) {
							getInstruments.push(response.instrument__instrument_name)
						}
					}
				)
		}




		for (let i = 0; i < tables.AssessementTwo.length; i++) {
			if (this.props.location.search.length !== 0 && tables.AssessementTwo[i].queryParams !== undefined) {
				tables.AssessementTwo[i].queryParams = this.props.location.search
			}
		}

		for (let i = 0; i < tables.AssessementFour.length; i++) {
			if (this.props.location.search.length !== 0 && tables.AssessementFour[i].queryParams !== undefined) {
				tables.AssessementFour[i].queryParams = this.props.location.search
			}
		}






		return (
			<div>
				<NavBar />

				{
					this.state.idLoader ?
						<div style={{ height: 'calc(100vh - 150px)' }} className="container d-flex justify-content-center">
							<LoaderComp color={'black'} />
						</div>
						:
						this.state.hasProperOrgId ?
							<div className="container custom-container my-5" >

								<div>
									<CommonBreadCrumb
										data={[
											{
												link: '/admin/app/dashboard',
												name: 'ADMIN'
											}, {
												link: '',
												name: 'ASSESSMENT SUMMARY'
											}
										]}
									/>
								</div>

								<div className="d-flex flex-row align-items-center justify-content-between" style={{ gap: '20px' }}>
									{/* Organisation Section */}
									<div className="d-flex align-items-center" style={{ width: '25%', gap: '10px' }}>
										<span className="me-3">Organisation</span>  {/* Increased margin */}
										{loading && <i className="fas fa-spinner fa-spin text-black spinner-position" />}
										<Input
											value={this.state.orgId}
											type="select"
											name="field"
											bsSize="sm"
											className="flex-grow-1"
											onChange={this.onChangeOrganisation}
										>
											<option value='null' key={0}>Select Organization</option>
											{!loading && !organisationError &&
												organisationResponse.map((organisation, i) => (
													<option value={organisation.id} key={i}>
														{organisation.organisation_name}
													</option>
												))
											}
										</Input>
									</div>

									{this.state.showTable && (
										<React.Fragment>
											{/* Batch Section */}
											<div className="d-flex align-items-center" style={{ width: '25%', gap: '10px' }}>
												<span className="me-3">Batch</span>  {/* Increased margin */}
												<Input
													value={this.state.BatchId}
													type="select"
													name="field"
													bsSize="sm"
													className="flex-grow-1"
													onChange={this.onChangeBatch}
												>
													<option value={null} key={0}>Unalloted</option>
													{!getBatchLoading &&
														batchListResponse.map((batch, i) => (
															<option value={batch.id} key={i}>
																{batch.batch_name}
															</option>
														))
													}
												</Input>
												<Link
													style={{ display: 'inline-flex', alignItems: 'center', gap: '2px', textDecorationColor: '#1aa388' }}
													target="_blank"
													to={this.state.BatchId === 'null' || this.state.BatchId === null
														? "/admin/app/organisation/" + this.state.orgId + "/manageBatches"
														: "/admin/app/organisation/" + this.state.orgId + "/manageBatches/" + this.state.BatchId
													}
												>
													<span className="text-green">Manage</span>
													<i className="fas fa-external-link-alt text-green"></i>
												</Link>
											</div>



											{/* Instrument Section */}
											<div className="d-flex align-items-center" style={{ width: '25%', gap: '10px' }}>
												<span className="me-3">Instrument</span>  {/* Increased margin */}
												<Input
													value={this.state.instrumentId}
													type="select"
													name="field"
													bsSize="sm"
													className="flex-grow-1"
													onChange={this.onChangeInstrument}
												>
													<option value={null}>All</option>
													<option value={2}>LOI</option>
													<option value={9}>LOI Self</option>
													<option value={3}>VVI</option>
												</Input>
											</div>
										</React.Fragment>
									)}
								</div>


								{
									this.state.orgId !== 'null' && assessmentResponse.length === 0 &&
									<p className="quattrocentosans bold text-center text-uppercase py-5">No Data to Display</p>
								}

								{
									this.state.showTable === true &&
									<Aux>
										{
											getInstruments.map(
												(instrument, i) => {
													{
														return (
															<Aux key={i}>
																<h5 className='mt-5' style={{ textDecoration: 'underline' }}>
																	{instrument} Report
																</h5>
																<div className="my-3">
																	<TableNew
																		columns={(this.getInstrumentType(instrument).data === true ? this.getInstrumentType(instrument).addGroupReport ? tables.AssessementOneGrpReport : tables.AssessementOne : this.getInstrumentType(instrument).addGroupReport ? tables.AssessementThreeGrpReport : tables.AssessementThree)}
																		data={this.getParticularInstrumentSummary(instrument)}
																		showSlNo="false"
																		defaultLink={true}
																		openModal={(data) => this.openModal(data, instrument)}
																		groupReportData={() => {
																			const assessmentIds = [];
																			let instrumentId = 0;
																			this.props.assessmentResponse.map(val => {
																				if (val.instrument__is_multi_rater === false) {
																					if (val.is_submited) {
																						assessmentIds.push(val.id)
																						instrumentId = val.instrument_id
																					}
																				}
																			})
																			localStorage.removeItem('download-obj');

																			// Set assessor_goup_id based on instrumentId
																			const assessorGroupId = instrumentId === 9 ? [0] : this.state.assessorId;

																			localStorage.setItem('download-obj', JSON.stringify({
																				key: 'group',
																				data: {
																					"seller_id": this.state.selId,
																					"organisation_id": this.state.orgId,
																					"instrument_id": instrumentId,
																					"assessor_goup_id": assessorGroupId,  // Now will be [0] when instrumentId is 9
																					"assessment_ids": assessmentIds
																				}
																			}))
																		}}
																	/>
																</div>
																<TableFilterComponent
																	assessment={this.props.assessmentResponse}
																	instrument={instrument}
																	dispatch={this.props.dispatch}
																	batchId={this.state.BatchId}
																	orgId={this.state.orgId}
																	instrumentId={this.state.instrumentId}
																/>
															</Aux>
														);
													}
												}
											)
										}
									</Aux>
								}
								{
									<Modal isOpen={this.state.groupReportModal} toggle={() => this.toggleEntireRelationModal()}>
										<ModalHeader toggle={() => this.toggleEntireRelationModal()}>GROUP REPORT DOWNLOAD</ModalHeader>

										<ModalBody>
											{
												this.state.showDropDownInModal &&
												<Select
													className="w-100"
													value={this.state.assessorSelectedOption}
													onChange={(data) => this.chooseAssessor(data)}
													options={this.state.assessorDropdownOption}
													isMulti={true}
												/>
											}
										</ModalBody>
										<ModalFooter>

											<Link onClick={
												() => {
													localStorage.removeItem('download-obj');
													localStorage.setItem('download-obj', JSON.stringify({
														key: 'group',
														data: {
															"seller_id": this.state.selId,
															"organisation_id": this.state.orgId,
															"instrument_id": this.state.instrumentId,
															"assessor_goup_id": this.state.assessorId,
															"assessment_ids": this.state.assessmentIds
														}
													}))
												}
											}
												to={{ pathname: `/app/dashBoard/viewReport/0/Download` }}
												target="_blank"
												className={this.state.reportDownloadDisable ? "btn btn-red text-uppercase disabled" : "btn btn-red btn-sm text-uppercase"}

											>DOWNLOAD GROUP REPORT</Link>
											<Button color="secondary" onClick={() => this.toggleEntireRelationModal(false)}>Cancel</Button>
										</ModalFooter>
									</Modal>

								}
							</div>
							:
							<Page404 />
				}
			</div>
		);
	}
}

class TableFilterComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			assessment: [],
			currentParticipant: '0',
			selectedAssessments: [],
			isLoading: false,
			isSendingMail: false,
			isDownloadingZip: false,
			zipDownloadStep: ''

		}
		this.tableRef = React.createRef();
	}

	componentDidMount() {
		const { instrument } = this.props;
		const data = [];
		this.props.assessment.map(
			(response, j) => {
				if (response.instrument__is_multi_rater && response.instrument__instrument_name === instrument) {
					data.push({
						'id': response.id,
						'instrument_type': response.instrument__is_multi_rater,
						'instrument__instrument_name': [response.instrument__instrument_name,
						response.instrument__instrument_image
						],
						'participant__email': response.participant__email,
						'participant__short_name': response.participant__short_name,
						'assessment_completed_count': response.assessment_completed_count + "/" + response.assessment_number_count,
						'respondent_count': response.respondent_completed + " of " + response.respondent_count + " completed",
						'is_submited': response.is_submited,
						'instrument__is_multi_rater': response.instrument__is_multi_rater,
						'all': response
					})
				}
				else if (response.instrument__is_multi_rater === false && response.instrument__instrument_name === instrument) {
					data.push({
						'id': response.id,
						'instrument_type': response.instrument__is_multi_rater,
						'instrument__instrument_name': [response.instrument__instrument_name,
						response.instrument__instrument_image
						],
						'participant__email': response.participant__email,
						'participant__short_name': response.participant__short_name,
						'assessment_completed_count': response.assessment_completed_count + "/" + response.assessment_number_count,
						'respondent_count': response.respondent_completed + " of " + response.respondent_count + " completed",
						'is_submited': response.is_submited,
						'instrument__is_multi_rater': response.instrument__is_multi_rater,
						'all': response
					})
				}
			})


		this.setState({
			mainAssessment: data,
			assessment: data
		})
	}


	handleSelectAll = (allChecked) => {
		const { assessment } = this.state;
		const selectedAssessments = allChecked ? assessment.map((item) => item.id) : [];
		this.setState({ selectedAssessments, allChecked });
	};

	updateHeaderCheckboxState = () => {
		const { assessment, selectedAssessments } = this.state;
		const isAllChecked = assessment.length === selectedAssessments.length;
		if (this.tableRef.current) {
			this.tableRef.current.setAllChecked(isAllChecked);
		}
	};



	handleCheckboxChange = (checked, assessment) => {
		const { selectedAssessments } = this.state;
		if (checked) {
			this.setState(
				{
					selectedAssessments: [...selectedAssessments, assessment.id],
				},
				() => {
					const allChecked = this.state.assessment.length === this.state.selectedAssessments.length;
					if (this.tableRef.current) {
						this.tableRef.current.setAllChecked(allChecked);
					}
				}
			);
		} else {
			this.setState(
				{
					selectedAssessments: selectedAssessments.filter((id) => id !== assessment.id),
				},
				() => {
					if (this.tableRef.current) {
						this.tableRef.current.setAllChecked(false);
					}
				}
			);
		}
	};



	downloadExcelReport = () => {
		const { selectedAssessments, allChecked } = this.state;
		const { dispatch } = this.props;
		const instrumentId = selectedAssessments.length > 0 ? this.state.assessment[0].all.instrument_id : null;

		if (instrumentId && selectedAssessments.length > 0) {
			const requestBody = {
				instrument_id: instrumentId,
				assessment_list: selectedAssessments,
			};

			// Make the API call to download the Excel report

			this.setState({ isLoading: true }, () => {
				Axios
					.post('/assessments/download/excel/report/assessment', requestBody, {
						responseType: 'blob', // Set the response type to 'blob'
					})
					.then((response) => {


						// Create a Blob from the response data
						const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

						// Create a temporary URL for the Blob
						const url = window.URL.createObjectURL(blob);

						// Create a link element and trigger the download
						const link = document.createElement('a');
						link.href = url;
						link.download = 'report.xlsx'; // Specify the desired filename
						link.click();

						// Clean up the temporary URL
						window.URL.revokeObjectURL(url);

						// Clear the selected assessments and update the state
						this.setState({ selectedAssessments: [], allChecked: false }, () => {
							// Update the header checkbox state directly
							this.updateHeaderCheckboxState();
							// Clear the header checkbox in the TableNew component
							if (this.tableRef.current) {
								this.tableRef.current.setState({ allChecked: false });
							}
						});

						// Dispatch the action to fetch assessment data if the header checkbox was checked
						if (selectedAssessments.length === this.state.assessment.length) {
							const data = {
								batch_id: this.props.batchId,
								organisation_id: this.props.orgId
							};



							if (this.props.instrumentId && this.props.instrumentId !== "null") {
								data.instrument_id = parseInt(this.props.instrumentId);
							}



							dispatch(getAssessementAction.getAssessementHandler(data));
						}
					})

					.catch((error) => {
						// Handle the error response
						if (error.response) {
							const errorMessage = error.response.data.error;

							swal({
								title: 'Error',
								text: "Select only submitted assessments",
								type: 'error',
								confirmButtonColor: '#3085d6',
								confirmButtonText: 'OK'
							});
						} else {
							swal({
								title: 'Error',
								text: 'An error occurred while downloading the Excel report.',
								type: 'error',
								confirmButtonColor: '#3085d6',
								confirmButtonText: 'OK'
							});
						}
					})
					.finally(() => {
						this.setState({ isLoading: false });
					});

			});
		}
	};

	sendMail = () => {
		const { selectedAssessments } = this.state;
		const { dispatch } = this.props;

		if (selectedAssessments.length > 0) {
			const requestBody = {
				assessment_list: selectedAssessments,
			};

			this.setState({ isSendingMail: true }, () => {
				Axios
					.post('/assessments/send/report/notify/', requestBody)
					.then((response) => {
						const { errors, success } = response.data;

						let message = "";

						if (success.length > 0) {
							message += "Successfully sent emails to:\n" + success.join("\n") + "\n\n";
						}

						if (errors.length > 0) {
							message += "Failed to send emails:\n";
							errors.forEach(error => {
								const email = Object.keys(error)[0];
								message += `${email}: ${error[email]}\n`;
							});
						}

						if (message) {
							swal({
								title: success.length > 0 ? 'Email Sent' : 'Email Send Failed',
								text: message,
								type: success.length > 0 ? 'success' : 'error',
								confirmButtonColor: '#3085d6',
								confirmButtonText: 'OK'
							});
						}

						// Clear the selected assessments and update the state
						this.setState({ selectedAssessments: [], allChecked: false }, () => {
							this.updateHeaderCheckboxState();
							if (this.tableRef.current) {
								this.tableRef.current.setState({ allChecked: false });
							}
						});

						// Refresh assessment data if all were selected
						if (selectedAssessments.length === this.state.assessment.length) {
							const data = {
								batch_id: this.props.batchId,
								organisation_id: this.props.orgId
							};

							// Add instrument_id if it exists
							if (this.props.instrumentId && this.props.instrumentId !== "null") {
								data.instrument_id = parseInt(this.props.instrumentId);
							}



							dispatch(getAssessementAction.getAssessementHandler(data));
						}
					})
					.catch((error) => {
						// Handle error
						swal({
							title: 'Error',
							text: 'An error occurred while sending emails.',
							type: 'error',
							confirmButtonColor: '#3085d6',
							confirmButtonText: 'OK'
						});
					})
					.finally(() => {
						this.setState({ isSendingMail: false });
					});
			});
		}
	};


	downloadZipFile = () => {
		const { selectedAssessments } = this.state;
		const { dispatch } = this.props;
	
		// Get instrument ID from the first selected assessment
		let selectedInstrumentId = null;
    if (selectedAssessments.length > 0) {
        const selectedAssessment = this.state.assessment.find(a => a.id === selectedAssessments[0]);
        if (selectedAssessment && selectedAssessment.all) {
            selectedInstrumentId = selectedAssessment.all.instrument_id;
        }
    }
	
		if (selectedAssessments.length > 40) {
			swal({
				title: 'Selection Limit Exceeded',
				text: 'Please select a maximum of 40 assessments at a time to avoid timeout issues.',
				type: 'warning',
				confirmButtonColor: '#3085d6',
				confirmButtonText: 'OK'
			});
			return;
		}
	
		const downloadSteps = [
			'Initializing process',
			'Fetching IDs',
			'Retrieving data',
			'Creating PDFs',
			'Compiling package',
			'Compressing files',
			'Finalizing download',
			'Starting download'
		];
	
		let currentStepIndex = 0;
	
		const updateStep = () => {
			if (currentStepIndex < downloadSteps.length) {
				this.setState({ zipDownloadStep: downloadSteps[currentStepIndex] });
				currentStepIndex++;
				setTimeout(updateStep, 7000);
			}
		};
	
		const urlParams = new URLSearchParams(window.location.search);
		const batchId = urlParams.get('batch');
	
		if (selectedAssessments.length > 0) {
			// Base request body
			let requestBody = {
				assessment_list: selectedAssessments,
				batch_id: batchId === 'unalloted' ? null : parseInt(batchId)
			};
	
			// Add additional payload based on instrument ID
			if (selectedInstrumentId === 9) {
				requestBody = {
					...requestBody,
					relation_group_id: 28,
					relation_group_name: "Self report",
					instrument_id: 9
				};
			} else if (selectedInstrumentId === 2) {
				requestBody = {
					...requestBody,
					relation_group_id: 10,
					relation_group_name: "360-Degree Feedback",
					instrument_id: 2
				};
			} else if (selectedInstrumentId === 3) {
				requestBody = {
					...requestBody,
					instrument_id: 3
				};
			}
	
			this.setState({
				isDownloadingZip: true,
				zipDownloadStep: downloadSteps[0]
			}, () => {
				updateStep();
	
				Axios
					.post('/assessments/download/bulk_report/zip/', requestBody)
					.then((response) => {
						if (response.data.status && response.data.url) {
							const link = document.createElement('a');
							link.href = response.data.url;
							link.setAttribute('download', 'assessment_reports.zip');
							link.setAttribute('target', '_blank');
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
	
							this.setState({ selectedAssessments: [], allChecked: false }, () => {
								this.updateHeaderCheckboxState();
								if (this.tableRef.current) {
									this.tableRef.current.setState({ allChecked: false });
								}
							});
	
							if (selectedAssessments.length === this.state.assessment.length) {
								const data = {
									batch_id: this.props.batchId,
									organisation_id: this.props.orgId
								};
	
								if (this.props.instrumentId && this.props.instrumentId !== "null") {
									data.instrument_id = parseInt(this.props.instrumentId);
								}
	
								dispatch(getAssessementAction.getAssessementHandler(data));
							}
						} else {
							throw new Error('Download URL not found in response');
						}
					})
					.catch((error) => {
						if (error.response && error.response.data && error.response.data.message) {
							swal({
								title: 'Error',
								text: error.response.data.message,
								type: 'error',
								confirmButtonColor: '#3085d6',
								confirmButtonText: 'OK'
							});
						} else {
							swal({
								title: 'Error',
								text: 'An error occurred while downloading the ZIP file.',
								type: 'error',
								confirmButtonColor: '#3085d6',
								confirmButtonText: 'OK'
							});
						}
					})
					.finally(() => {
						this.setState({
							isDownloadingZip: false,
							zipDownloadStep: '' // Reset step
						});
					});
			});
		}
	};














	getInstrumentType(instrument) {
		let data = null;
		this.props.assessment.map(
			(response, j) => {
				if (response.instrument__is_multi_rater === true && response.instrument__instrument_name === instrument) {
					data = true
				}
				else if (response.instrument__is_multi_rater === false && response.instrument__instrument_name === instrument) {
					data = false
				}
			})

		return data
	}

	filterParticipantData(e) {

		this.setState({
			currentParticipant: e.target.value
		}, () => {
			const { instrument } = this.props;
			let data = [];
			let assessment = [...this.state.mainAssessment];

			assessment.map(val => {

				if (val !== undefined) {
					if (this.state.currentParticipant === '0') {
						data.push(val)
					} else if (this.state.currentParticipant === '1') {
						let splitStr = val.respondent_count.split(" of ")
						let secondStringSplit = splitStr["1"].split(" completed");
						let secondString = secondStringSplit["0"]
						if (secondString === "0") {
							data.push(val)
						}
					} else if (this.state.currentParticipant === '2') {
						let splitStr = val.respondent_count.split(" of ")
						let secondStringSplit = splitStr["1"].split(" completed");
						let secondString = secondStringSplit["0"]
						if (secondString !== "0") {
							data.push(val)
						}
					} else if (this.state.currentParticipant === '3') {
						let splitStr = val.assessment_completed_count.split("/")
						if (parseInt(splitStr[1]) > parseInt(splitStr[0]) || parseInt(splitStr[0]) + parseInt(splitStr[1]) === 0) {
							data.push(val)
						}
					} else if (this.state.currentParticipant === '4') {
						let splitStr = val.assessment_completed_count.split("/")
						if (parseInt(splitStr[1]) === parseInt(splitStr[0]) && parseInt(splitStr[0]) + parseInt(splitStr[1]) !== 0) {
							data.push(val)
						}
					} else if (this.state.currentParticipant === '5') {
						if (val.is_submited === true) {
							data.push(val)
						}
					} else if (this.state.currentParticipant === '6') {
						if (val.is_submited === false) {
							data.push(val)
						}
					}
				}
			})
			this.setState({
				assessment: data
			})
		})

	}

	render() {
		const { instrument } = this.props;
		const { selectedAssessments } = this.state;







		return (
			<div className="my-md-5 my-3">
				<div className="row mb-2">
					<div className="col-12 d-flex align-items-center justify-content-end">
						{instrument !== 'VVI' && (
							<div className="d-flex align-items-center">
								<label className="mr-2 mb-0">FILTER</label>
								<Input
									value={this.state.currentParticipant}
									type="select"
									name="field"
									bsSize="sm"
									className="border-1 mr-2"
									style={{ height: '38px' }}
									onChange={(e) => this.filterParticipantData(e)}
								>
									<option value={0} key={0}>All</option>
									<option value={1} key={1}>Respondents not Invited</option>
									<option value={2} key={2}>Respondents Invited</option>
									<option value={3} key={3}>Self Not Completed</option>
									<option value={4} key={4}>Self Completed</option>
									<option value={5} key={5}>Submitted</option>
									<option value={6} key={6}>Not Submitted</option>
								</Input>
							</div>
						)}
						<Button
							style={{ height: '38px', backgroundColor: '#ee6452', border: 'none' }}
							disabled={selectedAssessments.length === 0 || this.state.isLoading}
							onClick={this.downloadExcelReport}
						>
							{this.state.isLoading ? (
								<span>
									<i className="fa fa-spinner fa-spin mr-2"></i>
									Downloading...
								</span>
							) : (
								'Download Excel Report'
							)}
						</Button>
						<Button
							style={{ height: '38px', backgroundColor: '#4CAF50', border: 'none', marginLeft: '10px' }}
							disabled={selectedAssessments.length === 0 || this.state.isLoading}
							onClick={this.sendMail}
						>
							{this.state.isSendingMail ? (
								<span>
									<i className="fa fa-spinner fa-spin mr-2"></i>
									Sending...
								</span>
							) : (
								'Send Mail'
							)}
						</Button>

					
							<Button
								style={{
									height: '38px',
									backgroundColor: '#2196F3',
									border: 'none',
									marginLeft: '10px',
									width: '200px', // Fixed width
									display: 'flex',  // Added for better alignment
									alignItems: 'center',
									justifyContent: 'center'
								}}
								disabled={selectedAssessments.length === 0 || this.state.isDownloadingZip}
								onClick={this.downloadZipFile}
							>
								{this.state.isDownloadingZip ? (
									<span style={{
										display: 'flex',
										alignItems: 'center',
										gap: '8px'  // Space between spinner and text
									}}>
										<i className="fa fa-spinner fa-spin" />
										{this.state.zipDownloadStep}
									</span>
								) : (
									'Download ZIP'
								)}
							</Button>

						



					</div>
				</div>

				<TableNew
					ref={this.tableRef}
					columns={this.getInstrumentType(instrument) === true ? tables.AssessementTwo : tables.AssessementFour}
					data={this.state.assessment}
					showSlNo="true"
					sortBy={(key) => this.sortBy(key, !this.state.sortType, 'assessmentTwo')}
					sortType={this.state.sortType}
					showCheckbox={true}
					selectedAssessments={this.state.selectedAssessments}
					handleCheckboxChange={this.handleCheckboxChange}
					handleSelectAll={this.handleSelectAll}
				/>

			</div>
		)
	}
}

function mapStateToProps(state) {

	const { loading } = state.organisation;
	const organisationError = state.organisation.error;


	const organisationResponse = (!loading && !organisationError) ? state.organisation.organisation.data.organisation_list : '';

	const { getBatchLoading } = state.getBatchAssessmentSummary;
	const getBatchAssessmentSummaryError = state.getBatchAssessmentSummary.error;
	const batchListResponse = (!getBatchLoading && !getBatchAssessmentSummaryError) ? state.getBatchAssessmentSummary.data.data.organisation_batch_list : '';

	const { getAssessmentLoading } = state.getAssessmentSummary;
	const getAssessmentSummaryError = state.getAssessmentSummary.error;
	const assessmentResponse = (!getAssessmentLoading && !getAssessmentSummaryError) ? state.getAssessmentSummary.data.data.response : '';

	return {
		loading,
		organisationResponse,

		getBatchLoading,
		batchListResponse,

		getAssessmentLoading,
		assessmentResponse,
	};
}

export default connect(mapStateToProps)(AssessmentSummary);


// WEBPACK FOOTER //
// ./src/_pages/Admin/AssessmentSummary/index.jsx